import { IColors, ITypography } from "@swiggy-private/dls-web-common/dist/components/types.internal";


export const getSubTextVariantAndColor = (
    isPHCallout: boolean,
    isJioHotstarFlow?: boolean
): { variant: keyof ITypography; color: keyof IColors } => {
    if (isJioHotstarFlow) {
        return {
            variant: "V2.body2.neutral.medium",
            color: "text_Med_Emphasis",
        };
    }

    if (isPHCallout) {
        return {
            variant: "V2.body2.neutral.regular",
            color: "text_Med_Emphasis",
        };
    }

    return {
        variant: "V2.body1.neutral.regular",
        color: "text_Highest_Emphasis",
    };
};

